import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Students.Data.StudentGroupData[]> {
  return axios.get(route('api.student-groups.search', filters)).then((res) => res.data);
}
